require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi.json") })
        }
      }, "path---news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi!./.cache/json/news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi!./.cache/json/news-c-1-wrb-uqfmh-3-x-pg-qw-wi-2-zvxi.json
// module chunks = 231608221292675